export const rotateArray = <T>(arr: readonly T[], offset: number): T[] => {
  if (arr.length === 0) {
    return [];
  }

  const hasIsNew = (item: T): item is T & { isNew?: boolean } =>
    typeof item === 'object' && item !== null && 'isNew' in item;

  const anyHasIsNew = arr.some(hasIsNew);

  const norm = (k: number, n: number) => ((k % n) + n) % n;

  if (!anyHasIsNew) {
    const k = norm(offset, arr.length);
    return arr.slice(k).concat(arr.slice(0, k));
  }

  const newItems: T[] = [];
  const oldItems: T[] = [];

  for (const item of arr) {
    if (hasIsNew(item) && item.isNew === true) {
      newItems.push(item);
    } else {
      oldItems.push(item);
    }
  }

  if (oldItems.length === 0) {
    return newItems.slice();
  }

  const k = norm(offset, oldItems.length);
  const rotatedOld = oldItems.slice(k).concat(oldItems.slice(0, k));

  return [...newItems, ...rotatedOld];
};
